import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { categories } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const category = categories.find((c) => c.slug === article.category);

  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/80 transition-all duration-300 flex flex-col">
      <Link to={`/article/${article.slug}`} className="block overflow-hidden">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={`${article.title} - 海角社区地址`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          {category && (
            <Link
              to={`/category/${category.slug}`}
              className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800 hover:bg-secondary-200 transition-colors whitespace-nowrap"
            >
              {category.name}
            </Link>
          )}
          <span className="text-xs text-foreground-500">{article.date}</span>
        </div>
        <Link to={`/article/${article.slug}`}>
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between mt-auto">
          <span className="text-xs text-foreground-500">{article.author}</span>
          <Link
            to={`/article/${article.slug}`}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1 transition-colors"
          >
            阅读全文
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}